import React, { Component } from 'react'

export interface ImgProps {
  src: string,
  alt?: string,
  fallback?: string
}

export default class Img extends Component<ImgProps, {
  fallback?: string
}> {
  state = {
    fallback: null
  }

  img = React.createRef<HTMLImageElement>()
  reload = e => {
    const { fallback } = this.props
    this.setState({ fallback })
  }

  componentDidMount(): void {
    this.img.current.addEventListener('error', this.reload)
  }

  componentWillUnmount(): void {
    this.img.current.removeEventListener('error', this.reload)
  }

  render(): React.ReactElement {
    const { src, alt, fallback, ...props } = this.props
    return <img
      { ...props }
      src={ this.state.fallback || src }
      alt={ alt }
      ref={ this.img }
    />
  }

}
